export const TOKEN = "token";
export const REFRESH_TOKEN = "refreshToken";
export const EMAIL = "email";
export const MESSAGEWAIT4SIGN = "messageWait4Sign";
export const ADVISOR_SSO_PENDING = "advisorSsoPending";
export const ADVISOR_SSO_ACTIVE = "advisorSsoActive";
export const ADVISOR_CONSULTATION_CONTEXT = "advisorConsultationContext";
